import React from 'react';
import { Users, Hammer, Clock, DollarSign, AlertTriangle, Timer } from 'lucide-react';
import { money, hrs } from './fabDashUtils';

const Tile = ({ icon: Icon, label, value, sub, tone = 'navy', testid }) => {
  const tones = {
    navy: 'border-l-blue-700 text-slate-900', green: 'border-l-emerald-500 text-emerald-700',
    amber: 'border-l-amber-500 text-amber-700', red: 'border-l-rose-600 text-rose-700', slate: 'border-l-slate-300 text-slate-500',
  };
  return (
    <div className={`bg-white rounded-xl border border-slate-200 border-l-4 ${tones[tone]} shadow-sm px-4 py-3 min-w-0`} data-testid={testid}>
      <div className="flex items-center justify-between gap-2">
        <p className="text-[11px] uppercase tracking-wide font-semibold text-slate-500 truncate">{label}</p>
        <Icon className="w-4 h-4 text-slate-500 shrink-0" />
      </div>
      <p className="text-2xl sm:text-3xl font-bold leading-tight mt-1 truncate">{value}</p>
      {sub && <p className="text-xs text-slate-500 mt-0.5 truncate">{sub}</p>}
    </div>
  );
};

export const KpiStrip = ({ s, costVisible }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3" data-testid="fab-kpi-strip">
    <Tile icon={Users} label="On the floor" value={s.crew_on_floor} tone={s.crew_on_floor > 0 ? 'green' : 'slate'}
      sub={`${s.crew_on_floor > 0 ? `${s.crew_working} on a job · ${s.crew_idle} idle` : 'Nobody clocked in'}${s.crew_on_site ? ` · ${s.crew_on_site} on site` : ''}${s.crew_done ? ` · ${s.crew_done} done` : ''}`} testid="kpi-floor" />
    <Tile icon={Hammer} label="Jobs in progress" value={s.in_progress} sub={`${s.open_jobs} open · ${s.waiting} waiting`} testid="kpi-jobs" />
    <Tile icon={Clock} label="Hours this week" value={hrs(s.hours_this_week)} sub={`${hrs(s.hours_today)} today`} testid="kpi-hours" />
    {costVisible && (
      <Tile icon={DollarSign} label="Running cost · open jobs" value={money(s.running_cost, { compact: true })}
        sub={s.job_value ? `vs ${money(s.job_value, { compact: true })} job value` : 'no job values on WO sheet'} testid="kpi-cost" />
    )}
    <Tile icon={AlertTriangle} label="At risk" value={s.at_risk} tone={s.at_risk > 0 ? 'red' : 'slate'}
      sub={`${s.late} past due · ${s.over_budget} over value`} testid="kpi-risk" />
    <Tile icon={Timer} label="Late today" value={s.late_today} tone={s.late_today > 0 ? 'amber' : 'slate'} sub="clock-ins after start" testid="kpi-late" />
  </div>
);
